// Language-aware route table. Danish is default (root); English lives under /en.

export const ROUTES = {
  home: { da: "/", en: "/en" },
  about: { da: "/om", en: "/en/about" },
  services: { da: "/ydelser", en: "/en/services" },
  service: { da: "/ydelser/:slug", en: "/en/services/:slug" },
  projects: { da: "/projekter", en: "/en/projects" },
  project: { da: "/projekter/:slug", en: "/en/projects/:slug" },
  techstacks: { da: "/tech-stacks", en: "/en/tech-stacks" },
  techstack: { da: "/tech-stacks/:slug", en: "/en/tech-stacks/:slug" },
  tool: { da: "/tech-stacks/:stack/:tool", en: "/en/tech-stacks/:stack/:tool" },
  blog: { da: "/viden", en: "/en/blog" },
  post: { da: "/viden/:slug", en: "/en/blog/:slug" },
  contact: { da: "/kontakt", en: "/en/contact" },
  sitemap: { da: "/sitemap", en: "/en/sitemap" },
};

import { toLangSlug, toDaSlug } from "./slug_map";

export function buildPath(key, lang, params = {}) {
  let p = (ROUTES[key] && ROUTES[key][lang]) || "/";
  // For detail routes, translate the slug into the target language so all
  // /en/ URLs use their English canonical slug (e.g. teknisk-seo → technical-seo).
  const KIND = { service: "service", project: "project", techstack: "stack", tool: "tool", post: "post" };
  const kind = KIND[key];
  Object.entries(params).forEach(([k, v]) => {
    let value = v;
    if (kind && k === "slug") value = toLangSlug(kind, v, lang);
    if (kind === "tool" && k === "stack") value = toLangSlug("stack", v, lang);
    if (kind === "tool" && k === "tool") value = toLangSlug("tool", v, lang);
    p = p.replace(`:${k}`, value);
  });
  return p;
}

// Detect language from a pathname
export function detectLang(pathname) {
  return pathname === "/en" || pathname.startsWith("/en/") ? "en" : "da";
}

export const SITE_URL = "https://magnusloev.dk";

/** Given a slug from a URL param + a kind, return the canonical DA slug used
 *  for API lookups. Frontend components use this before calling the API. */
export function canonicalSlug(kind, slug) {
  return toDaSlug(kind, slug);
}
